// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as HorBarChart from "../common/HorBarChart.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";

function StatsOverview(Props) {
  var count = Props.count;
  var place = Props.place;
  var top4 = Props.top4;
  var won = Props.won;
  var plDist = Props.plDist;
  var fullCount = Props.fullCount;
  var t = Translation.useT(/* Common */0);
  var plDist$1 = React.useMemo((function () {
          return Belt_Array.mapWithIndex(plDist, (function (idx, count) {
                        return [
                                String(idx + 1 | 0),
                                count
                              ];
                      }));
        }), [plDist]);
  return React.createElement("div", {
              className: "flex p-4 pt-5 text-base"
            }, React.createElement("div", undefined, React.createElement("div", {
                      className: "leading-none pb-3 font-montserrat font-medium"
                    }, t("Stats")), React.createElement("div", {
                      className: "grid gap-2 font-montserrat font-medium text-sm leading-none grid-cols-[minmax(auto,85px),auto] grid-rows-[repeat(4,14px)]"
                    }, React.createElement("div", {
                          className: "text-white2"
                        }, "Games:"), React.createElement("div", {
                          className: "font-semibold"
                        }, T.humanReadableCount(count)), React.createElement("div", {
                          className: "text-white2"
                        }, "Play rate:"), React.createElement("div", {
                          className: "font-semibold"
                        }, Global.toFixed(undefined, 8 * Global.f(count) / Global.f(fullCount)) + "/8"), React.createElement("div", {
                          className: "text-white2"
                        }, "Avg. place: "), React.createElement("div", {
                          className: "font-semibold"
                        }, Global.toFixed(undefined, place)), React.createElement("div", {
                          className: "text-white2"
                        }, "Top 4: "), React.createElement("div", {
                          className: "font-semibold"
                        }, Global.formatPct3(top4)), React.createElement("div", {
                          className: "text-white2"
                        }, "Win: "), React.createElement("div", {
                          className: "font-semibold"
                        }, Global.formatPct3(won)))), React.createElement("div", {
                  className: "pl-10"
                }, React.createElement("div", {
                      className: "leading-none pb-3 font-montserrat font-medium"
                    }, t("Placement distribution")), React.createElement(HorBarChart.V2.make, {
                      data: plDist$1
                    })));
}

var make = StatsOverview;

export {
  make ,
  
}
/* T Not a pure module */
